import { useState } from 'react';

import Divider from '@mindtickle/divider';
import EllipsisTooltip from '@mindtickle/ellipsis-tooltip';
import Label from '@mindtickle/label';
import { TEXT_COLORS, TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import { getPopupContainerOnBody } from '@mindtickle/utils';

import messages from '../../../Admin/messages';

import { StyledLogoWrapper } from './style';
import AnchorTag from './AnchorTag';
import { noop } from '@mindtickle/utils';
import { CompanyInfo } from '../../type';

type CompanyLogoProps = {
  company: CompanyInfo;
  isMetaInfoRequired?: boolean;
  isPageRefreshRequired?: boolean;
  redirectTo?: string;
  onLogoClick?: () => void;
  onCompanyNameClick?: () => void;
};

const CompanyLogo = ({
  company,
  isMetaInfoRequired = true,
  isPageRefreshRequired = true,
  redirectTo = '/',
  onLogoClick = noop,
  onCompanyNameClick = noop,
}: CompanyLogoProps) => {
  const [isLogoImageLoaded, setIsLogoImageLoaded] = useState(!company.companyLogo);
  const onImageLoad = () => setIsLogoImageLoaded(true);

  return (
    <StyledLogoWrapper>
      {!!company.companyLogo && (
        <AnchorTag
          isPageRefreshRequired={isPageRefreshRequired}
          data-testid={'nav-home'}
          className="global-header-logo"
          to={redirectTo}
          onClick={onLogoClick}
        >
          <img
            className="global-header-logo-img"
            src={company.companyLogo}
            alt={company.name}
            onLoad={onImageLoad}
          />
        </AnchorTag>
      )}
      <AnchorTag
        data-testid="gh-company-name"
        to={redirectTo}
        isPageRefreshRequired={isPageRefreshRequired}
        onClick={onCompanyNameClick}
      >
        <EllipsisTooltip
          key={isLogoImageLoaded ? 'LOGO_LOADED' : 'LOGO_LOADING'}
          getPopupContainer={getPopupContainerOnBody}
          wrapperClassName={`company-name-ellipsis ${TEXT_TYPES.HEADING_SMALL} ${TEXT_COLORS.DEFAULT}`}
          title={company.name}
        >
          {company.name}
        </EllipsisTooltip>
      </AnchorTag>

      {isMetaInfoRequired ? (
        <>
          <Divider type="vertical" />
          <Label
            type={TEXT_TYPES.BODY_MEDIUM_DEFAULT}
            color={TEXT_COLORS.TERTIARY}
            message={messages.ADMIN}
            data-testid="gh-admin-label"
          />
        </>
      ) : null}
    </StyledLogoWrapper>
  );
};

export default CompanyLogo;
